import React, { useState } from 'react';

import { Link, NavLink } from 'react-router-dom';

import narrativLogo from '../../../images/logos/narrativ_text_2.svg';
import narrativLogoWhite from '../../../images/logos/narrativ_text_white.svg';
import exitIcon from '../../../images/icons/X.png';
import hamburger from '../../../images/icons/hamburger-new.png';

import './new-login-nav.scss';

export default ({ isMobile, isPrivacy = false }) => {
  const [showModal, setModal] = useState(false);

  // Hide the modal if we've expanded into desktop-view
  if (!isMobile && showModal) {
    setModal(false);
  }

  const hamburgerOption = <img src={showModal ? exitIcon : hamburger} alt="narrativ menu" />;

  const logo = (
    <div className="logo">
      <img
        src={showModal ? narrativLogoWhite : narrativLogo}
        title="Narrativ"
        alt="Narrativ is the first real-time exchange
						 for premium publisher content."
      />
    </div>
  );

  const mobileHeader = (
    <div className="new-login-header">
      {logo}
      <div className={`${showModal ? 'exit' : 'hamburger'}`} onClick={() => setModal(!showModal)}>
        {hamburgerOption}
      </div>
    </div>
  );

  const modal = showModal ? (
    <div className="new-login-modal">
      {mobileHeader}
      <div className="modal-content">
        <div>
          <a className="home" href="https://narrativ.com">
            HOME
          </a>
        </div>
        <div>
          <NavLink className="sign-in" to="/v2/login">
            SIGN IN
          </NavLink>
        </div>
        <div>
          <NavLink className="privacy" to="/v2/privacy-policy">
            PRIVACY
          </NavLink>
        </div>
      </div>
    </div>
  ) : null;

  if (isMobile) {
    return (
      <>
        {mobileHeader}
        {modal}
      </>
    );
  }
  return (
    <div className="new-login-header">
      <div className="left-nav">
        <a className="home" href="https://narrativ.com">
          HOME
        </a>
        <NavLink className="privacy" to="/v2/privacy-policy">
          PRIVACY
        </NavLink>
      </div>
      {logo}
      <div className="right-nav">
        <Link className={`sign-in ${isPrivacy ? 'inactive' : 'active'}`} to="/v2/login">
          SIGN IN
        </Link>
      </div>
    </div>
  );
};
